<template>
    <div class="container">
        <div class="content-wrapper">
            <slot />
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .container {
        max-width: $max-width;
        margin: $spacing--4 auto;
        padding-inline: $spacing;

        @media (min-width: calc($max-width + $spacing)) {
            padding: 0;
        }
    }

    .content-wrapper {
        display: grid;
        grid-template-columns: 1fr;
        gap: $spacing;

        :slotted(.card-container) {
            grid-row: 1;
        }

        :slotted(.text) {
            grid-row: 2;
        }

        :slotted(.full-width) {
            grid-column: 1 / -1;
        }

        @media (min-width: $br-m) {
            grid-template-columns: 4fr 2fr;

            :slotted(.card-container),
            :slotted(.text) {
                grid-row: auto;
            }
        }
    }
</style>
